export interface Auth0PasswordResetConfig {
  domain: string
  clientId: string
  connection?: string
}

let config: Auth0PasswordResetConfig | null = null

export function setAuth0PasswordResetConfig(c: Auth0PasswordResetConfig): void {
  config = c
}

export function getAuth0PasswordResetConfig(): Auth0PasswordResetConfig {
  if (!config) {
    throw new Error('setAuth0PasswordResetConfig() must be called before requesting a password reset')
  }
  return config
}
